import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProvincesEffects } from './provinces.effects';
import { STORE_TYPE } from './provinces.model';
import { provincesReducer } from './provinces.reducer';

@NgModule({
  imports: [StoreModule.forFeature(STORE_TYPE, provincesReducer), EffectsModule.forFeature([ProvincesEffects])],
})
export class UIProvincesStoreModule {}